module.exports = __webpack_public_path__ + "fonts/BasierSquare-BoldItalic.1dd4f00.woff";